var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTel(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 32,
    height: 32,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.014 9.667c.861.718 1.406 2.204 1.216 3.3l-1.857 10.53c-.193 1.099-1.215 2.305-2.268 2.686L14.99 29.829c-1.054.38-2.62.103-3.48-.614L3.253 22.33c-.862-.72-1.408-2.202-1.214-3.3L3.895 8.5c.194-1.098 1.216-2.305 2.27-2.685L16.277 2.17c1.053-.38 2.62-.103 3.48.614l8.256 6.883zm-8.605 4.728.412-2.14-3.862.007.55-2.822h-1.251c-.001 0-1.17 2.09-3.748 3.115l-.356 1.845 1.69.003s-.572 2.653-.761 3.63c-.48 2.49.72 4.258 2.565 4.258h3.119l.545-2.364h-2.609c-1.158 0-1.098-.65-.875-1.806l.72-3.726 3.86.001z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTel);
export default __webpack_public_path__ + "static/media/TEL.8ea1696967bd758c8427f4c578d44b23.svg";
export { ForwardRef as ReactComponent };